import React from "react";
import IField from "../../../../interfaces/field";
import { Row } from "../../../ui";
import Input from "../input";
import Button from "../button";
import InputMask from "../input-mask";
import InputUpload from "../input-upload";
import InputRadio from "../input-radio";
import InputSwitch from "../input-switch";
import InputPhone from "../input-phone";
import SelectChecklist from "../select-checklist";
import InputPassword from "../input-password";
import Select from "../select";
import InputCheck from "../input-check";
import { Divider } from "./styles";
import Multiselect from "../multiselect";
import MultipleTextInput from "../multiple-text-input";
import Link from "../link";
import ActivitiesList from "../activities-list";
import Textarea from "../textarea";

type IProps = any & IField;
const InputGroup = ({
  inputs,
  style,
  hasDivider = false,
  ...el
}: IProps): JSX.Element | null => (
  <>
    <Row
      style={{
        gap: "15px",
        alignItems: "flex-start",
        justifyContent: "space-between",
        ...style,
      }}
    >
      {inputs.map(({ component, value, ...rest }: any) => {
        const ComponentsList = {
          Input,
          InputMask,
          InputPassword,
          InputRadio,
          InputSwitch,
          InputPhone,
          InputUpload,
          SelectChecklist,
          Button,
          Select,
          InputCheck,
          Multiselect,
          MultipleTextInput,
          InputGroup,
          Link,
          ActivitiesList,
          Textarea,
        };
        const Component =
          typeof component === "string"
            ? (ComponentsList as any)[component]
            : component;
        if (!Component) return null;

        const itemProps = { ...rest, ...el, value: value || "" };

        return (
          <Component key={`input-group-item-${rest.name}`} {...itemProps} />
        );
      })}
    </Row>
    {hasDivider && <Divider />}
  </>
);

export default InputGroup;
